<template lang="pug">
v-container.page-content(fluid)
  .page-content__inner(:style='styles')
    slot
</template>

<script setup>
defineOptions({
  name: 'BasePageContent',
})

const props = defineProps({
  maxWidth: {
    type: [Number, String],
    default: '88rem',
  },
})

const styles = computed(() => ({
  '--page-content-max-width':
    typeof props.maxWidth === 'number' ? `${props.maxWidth}px` : props.maxWidth,
}))
</script>

<style scoped>
.page-content {
  padding-inline: clamp(1rem, 2.5vw, 1.5rem);
}

.page-content__inner {
  width: min(100%, var(--page-content-max-width));
  margin: 0 auto;
}
</style>
